import React, { useState, useEffect } from 'react';
import { createCategoryGroup } from '../../../../services/menuPage';
import { fetchKitchens } from '../../../../services/dashboard/apiServiceDashboard';
import {
  TextField,
  Button,
  Typography,
  Paper,
  Box,
  Snackbar,
  Alert,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';

const CreateCategoryGroupForm = ({ onSuccess }) => {
  const [formData, setFormData] = useState({
    name: '',
    kitchen_id: '',
    note: '',
    image: null,
    printer_id: '', // ✅ Add printer_id to state
  });
  const [kitchens, setKitchens] = useState([]);
  const [printers, setPrinters] = useState([]); // ✅ Add printers state
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadKitchens = async () => {
      try {
        const data = await fetchKitchens();
        setKitchens(data);
      } catch (error) {
        console.error("❌ فشل في تحميل المطابخ:", error.message);
        setMessage({ type: 'error', text: 'فشل في تحميل المطابخ' });
      }
    };
    loadKitchens();
  }, []);

  useEffect(() => {
    // ✅ Load printers from API
    const loadPrinters = async () => {
      try {
        const res = await import('../../../../services/Settings/printers');
        const printersList = await res.getPrintersByBranch();
        setPrinters(printersList);
      } catch (error) {
        setMessage({ type: 'error', text: 'فشل في تحميل الطابعات' });
      }
    };
    loadPrinters();
  }, []);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);

    try {
      // السماح بإرسال printer_id فارغة (null أو "")
      const submitData = { ...formData };
      if (!submitData.printer_id) {
        submitData.printer_id = "";
      }
      const response = await createCategoryGroup(submitData);
      setMessage({ type: 'success', text: `✅ تم إنشاء المجموعة بنجاح: ${response.data?.name || formData.name}` });
      setFormData({ name: '', kitchen_id: '', note: '', image: null, printer_id: '' });

      if (onSuccess) onSuccess();
    } catch (error) {
      setMessage({ type: 'error', text: error.message });
    } finally {
      setLoading(false);
    }
  };

  const handleCloseSnackbar = () => setMessage(null);

  return (
    <Paper elevation={3} sx={{ p: 3, maxWidth: 600, mx: 'auto' }}>
      <Typography variant="h6" gutterBottom>إنشاء مجموعة أصناف جديدة</Typography>

      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <TextField
          label="اسم مجموعة الأصناف"
          name="name"
          value={formData.name}
          onChange={handleChange}
          fullWidth
          required
          margin="normal"
        />

        <FormControl fullWidth required margin="normal">
          <InputLabel>اختر المطبخ</InputLabel>
          <Select
            name="kitchen_id"
            value={formData.kitchen_id}
            onChange={handleChange}
            label="اختر المطبخ"
          >
            {kitchens.map((kitchen) => (
              <MenuItem key={kitchen.id} value={kitchen.id}>
                {kitchen.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* ✅ Printer select */}
        <FormControl fullWidth margin="normal">
          <InputLabel>اختر الطابعة</InputLabel>
          <Select
            name="printer_id"
            value={formData.printer_id}
            onChange={handleChange}
            label="اختر الطابعة"
          >
            <MenuItem value="">
              بدون طابعة
            </MenuItem>
            {printers.map((printer) => (
              <MenuItem key={printer.id} value={printer.id}>
                {printer.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <TextField
          label="ملاحظة"
          name="note"
          value={formData.note}
          onChange={handleChange}
          fullWidth
          multiline
          rows={2}
          margin="normal"
        />

        <Box mt={2}>
          <input
            type="file"
            name="image"
            accept="image/*"
            onChange={handleChange}
          />
        </Box>

        <Button
          type="submit"
          variant="contained"
          color="primary"
          fullWidth
          sx={{ mt: 3 }}
          disabled={loading}
        >
          {loading ? 'جارٍ الإرسال...' : 'إنشاء المجموعة'}
        </Button>
      </form>

      {message && (
        <Snackbar open autoHideDuration={4000} onClose={handleCloseSnackbar}>
          <Alert onClose={handleCloseSnackbar} severity={message.type} sx={{ width: '100%' }}>
            {message.text}
          </Alert>
        </Snackbar>
      )}
    </Paper>
  );
};

export default CreateCategoryGroupForm;
